module.exports = __webpack_public_path__ + "static/media/payments.d2384934.svg";